var map = {
	"./16/archive.svg": 82317,
	"./16/arrow-button.svg": 77177,
	"./16/arrow-circle.svg": 78937,
	"./16/arrow-left.svg": 39814,
	"./16/arrow-right.svg": 33573,
	"./16/arrow-s-down.svg": 6753,
	"./16/arrow-s-left.svg": 67898,
	"./16/arrow-s-right.svg": 89809,
	"./16/arrow-s-up.svg": 53438,
	"./16/assignee.svg": 32820,
	"./16/attachment.svg": 31398,
	"./16/back.svg": 29896,
	"./16/bell.svg": 53794,
	"./16/board-template.svg": 422,
	"./16/board.svg": 48903,
	"./16/card.svg": 48707,
	"./16/close.svg": 95823,
	"./16/color-tag.svg": 59677,
	"./16/color.svg": 68186,
	"./16/comment.svg": 98456,
	"./16/copy.svg": 20154,
	"./16/delete.svg": 22220,
	"./16/description.svg": 60161,
	"./16/done-circle.svg": 74006,
	"./16/done.svg": 52857,
	"./16/dot.svg": 27526,
	"./16/drive.svg": 25295,
	"./16/due-date.svg": 56978,
	"./16/emoji.svg": 28881,
	"./16/epic.svg": 75818,
	"./16/estimate.svg": 86319,
	"./16/eye.svg": 4288,
	"./16/feather.svg": 18594,
	"./16/forward.svg": 65180,
	"./16/info.svg": 2777,
	"./16/link.svg": 7073,
	"./16/list.svg": 17093,
	"./16/mention.svg": 39829,
	"./16/milestone.svg": 30269,
	"./16/more.svg": 32214,
	"./16/move-to.svg": 62160,
	"./16/overdue.svg": 43871,
	"./16/pen.svg": 36350,
	"./16/plus.svg": 25105,
	"./16/priority-critical.svg": 87065,
	"./16/priority-high.svg": 55914,
	"./16/priority-low.svg": 54900,
	"./16/priority-medium.svg": 92191,
	"./16/priority-no.svg": 21623,
	"./16/priority-normal.svg": 51031,
	"./16/rename.svg": 6399,
	"./16/sand-clock.svg": 12538,
	"./16/spent-time.svg": 16815,
	"./16/star.svg": 46289,
	"./16/start-date.svg": 45004,
	"./16/subcard.svg": 3567,
	"./16/tag.svg": 51551,
	"./16/weight.svg": 9257,
	"./24/account-settings.svg": 73729,
	"./24/account.svg": 32525,
	"./24/acrhive-epic.svg": 73274,
	"./24/acrhive-subcard.svg": 26655,
	"./24/activity.svg": 16407,
	"./24/add-notification.svg": 33779,
	"./24/archive.svg": 746,
	"./24/arrow-circle.svg": 88272,
	"./24/arrow-down.svg": 56584,
	"./24/arrow-left.svg": 81127,
	"./24/arrow-right.svg": 17026,
	"./24/arrow-s-drop-close.svg": 86708,
	"./24/arrow-s-drop-open.svg": 85432,
	"./24/arrow-s-left-open.svg": 35156,
	"./24/arrow-s-right-open.svg": 29067,
	"./24/arrow-up.svg": 46139,
	"./24/assigned-by-me.svg": 40005,
	"./24/attachment.svg": 5879,
	"./24/author.svg": 99185,
	"./24/back.svg": 71737,
	"./24/bell-no.svg": 67161,
	"./24/bell.svg": 15507,
	"./24/board-favorite.svg": 55269,
	"./24/board-template.svg": 92463,
	"./24/board.svg": 99872,
	"./24/calendar-30.svg": 17390,
	"./24/calendar-7.svg": 19134,
	"./24/calendar-adjust.svg": 1278,
	"./24/calendar-done.svg": 38759,
	"./24/calendar-future.svg": 45830,
	"./24/calendar-past.svg": 60123,
	"./24/calendar-today.svg": 82118,
	"./24/calendar-tomorrow.svg": 1566,
	"./24/calendar.svg": 34066,
	"./24/card-assigned.svg": 11003,
	"./24/card-color.svg": 52492,
	"./24/card.svg": 37946,
	"./24/chage-account.svg": 84932,
	"./24/chart.svg": 81496,
	"./24/check-multi.svg": 16072,
	"./24/checklist-add-items.svg": 88197,
	"./24/checklist-circle.svg": 50989,
	"./24/checklist.svg": 79392,
	"./24/clear.svg": 91591,
	"./24/click-selector.svg": 30722,
	"./24/close.svg": 80644,
	"./24/cloud-download.svg": 9628,
	"./24/cloud-upload.svg": 71599,
	"./24/collapse.svg": 56373,
	"./24/color-tag.svg": 21066,
	"./24/comment.svg": 86975,
	"./24/contributed.svg": 75903,
	"./24/cookie.svg": 26306,
	"./24/copy.svg": 77207,
	"./24/credit-card.svg": 98930,
	"./24/custom-fields.svg": 1501,
	"./24/delete.svg": 65945,
	"./24/description.svg": 12262,
	"./24/document-shared.svg": 66355,
	"./24/document.svg": 81411,
	"./24/done-circle.svg": 9085,
	"./24/done.svg": 94032,
	"./24/drive.svg": 49867,
	"./24/dropdown.svg": 24151,
	"./24/due-date.svg": 57123,
	"./24/email.svg": 13416,
	"./24/emoji.svg": 89626,
	"./24/empty-circle.svg": 24680,
	"./24/epic-card.svg": 40890,
	"./24/error.svg": 41314,
	"./24/estimate.svg": 30578,
	"./24/expand.svg": 99160,
	"./24/export-document.svg": 28712,
	"./24/eye.svg": 59247,
	"./24/facebook.svg": 68948,
	"./24/filters.svg": 50161,
	"./24/flash.svg": 68790,
	"./24/folder-account.svg": 90298,
	"./24/folder-attachments.svg": 68349,
	"./24/forward.svg": 17511,
	"./24/gantt-chart.svg": 31285,
	"./24/gmail.svg": 78186,
	"./24/google-apps.svg": 46918,
	"./24/google-color.svg": 95027,
	"./24/google-docs.svg": 49723,
	"./24/google-forms.svg": 84931,
	"./24/google-sheets.svg": 48626,
	"./24/google-slides.svg": 32136,
	"./24/grid-view-24.svg": 32713,
	"./24/height-auto.svg": 46740,
	"./24/height-resize.svg": 46722,
	"./24/help.svg": 83889,
	"./24/hint-arrow-down.svg": 9500,
	"./24/hint-arrow-left.svg": 907,
	"./24/hint-arrow-right.svg": 73006,
	"./24/hint-arrow-up.svg": 97367,
	"./24/image.svg": 65271,
	"./24/import-document.svg": 21875,
	"./24/info.svg": 22524,
	"./24/kanban-default.svg": 2265,
	"./24/kanban.svg": 66509,
	"./24/kanbanchi-logo.svg": 36475,
	"./24/keyboard-shortcuts.svg": 44689,
	"./24/knowlege.svg": 51848,
	"./24/like.svg": 36161,
	"./24/link.svg": 27696,
	"./24/linkedin.svg": 68686,
	"./24/list-view.svg": 98854,
	"./24/live.svg": 13470,
	"./24/lock.svg": 62517,
	"./24/mail.svg": 85,
	"./24/menu.svg": 60693,
	"./24/microsoft.svg": 22780,
	"./24/milestone.svg": 70166,
	"./24/minus.svg": 82440,
	"./24/monetization.svg": 69699,
	"./24/more.svg": 62827,
	"./24/mouse-over.svg": 9168,
	"./24/move-to-rect.svg": 49814,
	"./24/move-to.svg": 57251,
	"./24/move.svg": 44199,
	"./24/no.svg": 17901,
	"./24/notifications.svg": 86756,
	"./24/overdue.svg": 82456,
	"./24/pen.svg": 3697,
	"./24/pin.svg": 11069,
	"./24/play.svg": 44382,
	"./24/plus-circle.svg": 80045,
	"./24/plus.svg": 46752,
	"./24/predecessor.svg": 68475,
	"./24/prefix.svg": 70268,
	"./24/print.svg": 67509,
	"./24/priority-critical.svg": 24394,
	"./24/priority-high.svg": 5441,
	"./24/priority-low.svg": 63645,
	"./24/priority-medium.svg": 13312,
	"./24/priority-no.svg": 70292,
	"./24/priority-normal.svg": 49771,
	"./24/progress.svg": 38977,
	"./24/project-favorite.svg": 21380,
	"./24/project-template.svg": 83550,
	"./24/project.svg": 63999,
	"./24/pulse.svg": 37387,
	"./24/push-calendar.svg": 53827,
	"./24/read-notification.svg": 96708,
	"./24/related-card.svg": 45944,
	"./24/rename.svg": 35742,
	"./24/replay.svg": 61850,
	"./24/reply.svg": 97540,
	"./24/search.svg": 53820,
	"./24/send.svg": 93450,
	"./24/settings.svg": 70855,
	"./24/share-domain-link.svg": 48527,
	"./24/share-domain.svg": 16626,
	"./24/share-link.svg": 1254,
	"./24/share-public.svg": 46089,
	"./24/share-specific.svg": 93350,
	"./24/sign-out.svg": 98136,
	"./24/sort-down-up.svg": 97705,
	"./24/sort-up-down.svg": 32491,
	"./24/sort.svg": 79260,
	"./24/sparkles.svg": 33249,
	"./24/spent-time.svg": 57082,
	"./24/star.svg": 9824,
	"./24/start-date.svg": 40997,
	"./24/start.svg": 30268,
	"./24/status.svg": 64286,
	"./24/subcard.svg": 69752,
	"./24/subscribed.svg": 8708,
	"./24/support-form.svg": 27688,
	"./24/support.svg": 93237,
	"./24/swimlanes.svg": 44061,
	"./24/tag.svg": 66112,
	"./24/text.svg": 23493,
	"./24/trello.svg": 39506,
	"./24/twitter.svg": 63397,
	"./24/user.svg": 72161,
	"./24/visibility-off.svg": 9184,
	"./24/weight.svg": 95488,
	"./24/workload.svg": 62219,
	"./24/youtube.svg": 32027,
	"./24/zoom-in.svg": 14663,
	"./24/zoom-out.svg": 68178,
	"./96/announcement.svg": 52612,
	"./96/c-burn-down.svg": 63711,
	"./96/c-burn-up.svg": 40144,
	"./96/c-comulative-flow.svg": 47287,
	"./96/c-productivity.svg": 75249,
	"./96/c-team-performance.svg": 47791,
	"./96/create-first-board.svg": 39035,
	"./96/create-new-template.svg": 91679,
	"./96/e-archive.svg": 62963,
	"./96/e-board.svg": 11213,
	"./96/e-comments.svg": 90097,
	"./96/e-search-data.svg": 51752,
	"./96/e-search-folder.svg": 17284,
	"./96/e-search-users.svg": 64880,
	"./96/e-starred-folder.svg": 54421,
	"./96/expired-subscription.svg": 8562,
	"./96/get-feature.svg": 68142,
	"./96/get-premium.svg": 90063,
	"./96/lock-action.svg": 23735,
	"./96/permissions.svg": 88587,
	"./96/t-5-things-concept.svg": 91766,
	"./96/t-agile.svg": 43664,
	"./96/t-business-canvas.svg": 96015,
	"./96/t-classic-kanban.svg": 67220,
	"./96/t-content-creation.svg": 99647,
	"./96/t-development.svg": 92239,
	"./96/t-edu.svg": 85784,
	"./96/t-event-planning.svg": 90638,
	"./96/t-freemium-model.svg": 9150,
	"./96/t-kanban-priority.svg": 48882,
	"./96/t-mvp-creation.svg": 80211,
	"./96/t-teams-collaboration.svg": 74642,
	"./96/t-weekly-planning.svg": 91581,
	"./96/template-user.svg": 5369,
	"./96/video-tutorials.svg": 27588,
	"./96/warning.svg": 53403,
	"./96/well-done.svg": 45930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2556;